@if (!!(searchQuery$ | async) && (loading$ | async) === false) {
  <div class="search-results container container-size-sm">
    <ul class="search-results__list">
      @if (!(searchResults$ | async)?.length && (loading$ | async) === false && !!(searchQuery$ | async)) {
        <li class="product-list-item is--empty-state">
          <div>
            <span>{{ 'zoek-geen-producten-gevonden' | fromDictionary }}</span>
            <!--<strong>{{ searchQuery$ | async }}</strong>-->
          </div>
        </li>
      }
      @for (product of searchResults$ | async; track product.id) {
        <li class="product-list-item">
          <a [routerLink]="['/', 'products', product?.handle]">
            @if (product?.images?.length && product?.images?.[0]?.url) {
              <img
                [src]="product?.images?.[0]?.url"
                [alt]="product?.images?.[0]?.altText || product?.title"
                class="product-image-ratio product-list-item__image"
              />
            }
            @if (product && !product?.images?.[0]?.url) {
              <img
                [src]="'product-placeholder-afbeelding' | fromDictionary"
                [alt]="product.images?.[0]?.altText || product.title"
                class="product-image-ratio product-list-item__image"
              />
            }
            <div class="product-list-item__content">
              <span class="me-1 product-list-item__content__title">
                <span [class.text-muted]="!product?.availableForSale">{{ product.title }}</span>
                @if (getCustomLabel(product)?.value) {
                  &nbsp;
                  <span class="chip-label type-body-sm chip--outline chip--primary chip--xs">
                    {{ getCustomLabel(product)?.value }}
                  </span>
                }
              </span>
              @if (product?.priceRange?.minVariantPrice; as minPrice) {
                <span class="product-list-item__content__meta type-body-md">
                  <small class="me-1 type-body-xs">{{ 'product-card-vanaf-prijf-prefix' | fromDictionary }}</small>
                  <span>{{ minPrice?.amount | currency: minPrice.currencyCode }}</span>
                </span>
              }
            </div>
          </a>
        </li>
      }
    </ul>
  </div>
}
